import type React from "react";
import { type DialogButtonType } from "../Layout/Dialog/Dialog";

export type DialogType = "normal" | "danger";

export const SHOW_DIALOG = "SHOW_DIALOG";
export const HIDE_DIALOG = "HIDE_DIALOG";
export const CLEAR_DIALOG = "CLEAR_DIALOG";

interface ShowDialogAction {
    type: typeof SHOW_DIALOG;
    title: string;
    content: React.ReactNode;
    buttons: Array<DialogButtonType>;
    dialogType: DialogType;
    wide: boolean;
}

interface HideDialogAction {
    type: typeof HIDE_DIALOG;
}

interface ClearDialogAction {
    type: typeof CLEAR_DIALOG;
}

export type DialogActionTypes = ShowDialogAction | HideDialogAction | ClearDialogAction;

export function showDialog(
    title: string,
    content: React.ReactNode,
    buttons: Array<DialogButtonType> = [],
    type: DialogType = "normal",
    wide = false
): DialogActionTypes {
    return {
        type      : SHOW_DIALOG,
        dialogType: type,
        buttons,
        content,
        title,
        wide,
    };
}

export function hideDialog(): DialogActionTypes {
    return {
        type: HIDE_DIALOG,
    };
}

export function clearDialog(): DialogActionTypes {
    return {
        type: CLEAR_DIALOG,
    };
}
